<template>
  <video-player :style="getStyle()" :options="videoOptions" />
</template>

<script>
import VideoPlayer from './VideoPlayer'

export default {
  name: 'VideViewer',
  components: {
    VideoPlayer,
  },
  props: {
    autoplay: {
      type: Boolean,
      default: true,
    },
    controls: {
      type: Boolean,
      default: true,
    },
    poster: {
      type: String,
      default: null,
    },
    src: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      default: 'video/mp4',
    },
    width: {
      type: String,
      default: '100%',
    },
    height: {
      type: String,
      default: 'auto',
    },
    minHeight: {
      type: String,
      default: null,
    },
    maxHeight: {
      type: String,
      default: null,
    },
  },
  computed: {
    videoOptions() {
      return {
        autoplay: this.autoplay,
        controls: this.controls,
        poster: this.poster,
        sources: [
          {
            src: this.src,
            type: this.type,
          },
        ],
      }
    },
  },
  methods: {
    getStyle() {
      if (this.maxHeight && this.minHeight) {
        return `position: relative; width: ${this.width}; height: ${this.height}; min-height: ${this.minHeight}; max-height: ${this.maxHeight};`
      } else {
        return `position: relative; width: ${this.width}; height: ${this.height};`
      }
    },
  },
}
</script>
